<template>
  <div class="page">
    <div class="container">
      <div class="column">
        <div class="content" v-if='curso && !loading' >
          <div style="text-align:center">
            <img v-if='curso.imagem_original' :src='`http://www.espacowinnicottbsb.com.br/${curso.imagem_thumb}`' />
          </div>
          <h3>{{curso.titulo}}</h3>
          <div v-html='curso.descricao'></div>
          <br />
          <h4>Inscrições:</h4>
          <p> <b> de </b> {{formatInscricao(curso.inscricoes_inicio)}} <b> a </b> {{formatInscricao(curso.inscricoes_fim)}}  </p>
          <br />
          <div v-if='curso.local'>
            <h4>Local:</h4>
            <p>{{curso.local}}</p>
          </div>
          <br />
          <div v-if='curso.planos.length'>
            <h4>Investimento:</h4>
            <div v-for='p in curso.planos'>
              <h6>{{p.titulo}}</h6>
              <p>R$ {{p.valor}}</p>
              <br />
            </div>
          </div>
          <el-button type="primary" @click='$router.push(`/p/curso/${curso.id}/inscricao`)'>Desejo me inscrever neste curso</el-button>
        </div>
        <div v-if='loading' class="is-size-5">
          Aguarde... Estamos carregando as informações do curso
        </div>
        <div v-if='!curso && !loading' class="is-size-5">
          Não foi possível encontrar o curso que você procura
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment'

export default {
  name: 'QuemSomos',
  data(){
    return {
      curso: null,
      loading: false,
    }
  },
  methods:{
    handleClick() {
        console.log('click');
    },
    getCurso(){
      this.loading = true;
      axios.get(`${global.base}/api/curso/${this.$router.currentRoute.params.curso}`,{
        }).then((r)=>{
          this.curso = r.data;
          this.loading = false;
        }).catch(()=>{
          this.curso = null;
          this.loading = false;
        })
    },
    formatInscricao(f){
      return moment(f, "%Y-%MM-%DD").format("DD [de] MMMM [de] YYYY");
    }
  },
  mounted(){
    this.getCurso();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page{
    text-align: left
  }
  .container{
    max-width: 800px;
  }
</style>
